import React from 'react';
import PropTypes from 'prop-types';

import AccountMenu from './AccountMenu';

import './Header.css';

const Header = ({ appTitle, ...childProps }) => (
  <header className="App-header">
    <div className="App-logo" />
    <h1 className="App-title">{appTitle}</h1>
    <AccountMenu className="accountMenu" {...childProps} />
  </header>
);

Header.propTypes = {
  appTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js